import React from 'react';
import { Box } from '@zillow/constellation';
import CalculatorLayout from '../CalculatorLayout/CalculatorLayout.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import CashOutRefinanceFields from './CashOutRefinanceFields.js';
import CashOutRefinanceContent from './CashOutRefinanceContent.js';
import { isEditor } from '../../utils/isEditor.js';
import { omitUndefined } from '../../utils/lodash.js';
import { FieldConfig } from './CashOutRefinanceCalculator.utils.js';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';

var CashOutRefinanceCalculator = function CashOutRefinanceCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues;
  return /*#__PURE__*/React.createElement(CalculatorForm, {
    fieldStorageKey: "cashOutRefinanceFields",
    editorMode: isEditor(),
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.homeValue.name] = 250000, _Object$assign[FieldConfig.currentMortgageBalance.name] = 10000, _Object$assign[FieldConfig.newLoanTerm.name] = LOAN_PROGRAMS.fixed20Year, _Object$assign[FieldConfig.newInterestRate.name] = 4.35, _Object$assign[FieldConfig.adjustCashOutAmount.name] = 190000, _Object$assign[FieldConfig.fees.name] = 1000, _Object$assign[FieldConfig.rollFees.name] = false, _Object$assign), omitUndefined(defaultValues))
  }, /*#__PURE__*/React.createElement(Box, {
    as: CalculatorLayout,
    sxOverride: {
      '@media $sm_lte': {
        flexDirection: 'column-reverse'
      }
    },
    fields: /*#__PURE__*/React.createElement(CashOutRefinanceFields, null),
    content: /*#__PURE__*/React.createElement(CashOutRefinanceContent, null)
  }));
};
var CashOutRefinanceCalculator$1 = CashOutRefinanceCalculator;

export { CashOutRefinanceCalculator$1 as default };
